import { getDomPath } from '../../utils/data-manipulation';
import logger from '../../utils/logger';
import {getRouterBasename} from '../../utils/get-router-basename';

export const RemoteControlEventType = {
  ADD_EXTRA_WATER: 'addExtraWater',
  ABORT: 'abort',
  BATCH: 'batch',
  CLICK: 'click',
  FINISH_BATCH: 'finishBatch',
  FINISH_FEED_DEVICE: 'finishFeedDevice',
  FINISH_DISCHARGE_DEVICE: 'finishDischargeDevice',
  HOLD_LOAD: 'holdLoad',
  INFO: 'info',
  MOUSEDOWN: 'mousedown',
  MOUSEUP: 'mouseup',
  REMOVE_LOAD: 'removeLoad',
  RESUME_LOAD: 'resumeLoad',
  REMOVE_FROM_QUEUE: 'removeFromQueue',
  START_QUEUE: 'startQueue',
  USER_INFO: 'userInfo',
};

const MAIN_DOM_SELECTOR = '.device-dom-canvas';
const BATCH_TAB_SELECTOR = 'a[href=\'/batch/\']';

/**
 *
 * @param {RemoteControlEventType | string} type
 * @param {string | null} [selector]
 * @param {object | null} [data]
 * @returns {RemoteBatchData | *}
 * @constructor
 */
export const RemoteBatchData = (type, selector, data) => {
  return {
    type,
    selector,
    batchData: data,
  };
};

export const initRemoteBatchListener = (callback = () => {}) => {
  const eventListener = (e, type) => {
    const selector = getDomPath(e.target);
    const node = document.querySelector(`${MAIN_DOM_SELECTOR} ${selector}`);
    logger.debug(type, selector, node);

    if (!node || !type) {
      return;
    }

    if (type !== RemoteControlEventType.CLICK && selector.includes('btn-non-device')) {
      return;
    }

    if (
      (type ===  RemoteControlEventType.CLICK)
      && (
        selector.includes('btn-non-device-abort')
      || selector.includes('btn-non-device-batch')
      || selector.includes('btn-non-device-material')
      )
    ) {
      return;
    }

    callback(RemoteBatchData(type, selector));
  };

  window.addEventListener('click', (e) => {
    eventListener(e, RemoteControlEventType.CLICK);
  });

  window.addEventListener('mousedown', (e) => {
    eventListener(e, RemoteControlEventType.MOUSEDOWN);
  });

  window.addEventListener('mouseup', (e) => {
    eventListener(e, RemoteControlEventType.MOUSEUP);
  });
};

export const executeRemoteCode = (remoteBatchData, onError = () => {}) => {
  const { selector, type } = remoteBatchData;

  if (!selector || !type) {
    return;
  }

  const node = document.querySelector(`${MAIN_DOM_SELECTOR} ${selector}`);

  if (!node) {
    const batchTabNode = document.querySelector(BATCH_TAB_SELECTOR);

    if (window.location.pathname !== `${getRouterBasename()}/` && batchTabNode) {
      onError(`remote batch -> ${type} -> node not found: ${window.location.pathname} -> ${getRouterBasename()}/`);
      batchTabNode.click();
      return;
    }

    onError(`remote batch -> ${type} -> node not found -> ${selector} ${window.location.pathname}`);

    return;
  }

  switch (type) {
    case RemoteControlEventType.CLICK:
      node.click();
      break;
    case RemoteControlEventType.MOUSEDOWN:
    case RemoteControlEventType.MOUSEUP:
      node.dispatchEvent(new MouseEvent(type, {
        bubbles: true,
        cancelable: true,
        view: window,
      }));
      break;
    default:
      logger.log(`remote batch -> unknown event type: ${type} ${window.location.pathname}`);
  }
};
